import React from 'react';
import { BookOpen, GraduationCap, Award, Globe } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const SyllabusPage = () => {
  const syllabusOptions = [
    {
      name: 'CBSE',
      description: "'Central Board of Secondary Education - India's largest educational board",
      icon: BookOpen,
      color: 'blue',
      gradient: 'from-blue-500 to-cyan-500',
      features: ['Nationwide curriculum', 'Competitive exams focus', 'Comprehensive subjects']
    },
       {
  name: 'ICSE',
  description: 'ICSE - Comprehensive Indian curriculum with emphasis on practical knowledge',
  icon: BookOpen, // or GraduationCap, Award
  color: 'green',
  gradient: 'from-green-600 to-emerald-500',
  features: ['Extensive syllabus', 'Practical approach', 'English proficiency', 'Balanced academics']
},
    {
      name: 'Kerala State',
      description: 'Kerala State Board - Regional curriculum with Malayalam medium',
      icon: Award,
      color: 'orange',
      gradient: 'from-orange-500 to-red-500',
      features: ['Regional focus', 'Cultural studies', 'State-specific subjects']
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-700 to-indigo-800 text-white py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 text-6xl">📚</div>
          <div className="absolute bottom-10 right-20 text-8xl">🎓</div>
          <div className="absolute top-1/2 left-1/3 text-7xl">📖</div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Syllabus Options</h1>
            <p className="text-blue-100 max-w-2xl mx-auto text-lg">
              Choose from our comprehensive syllabus options tailored for different educational boards
            </p>
          </div>
        </div>
      </div>

      {/* Syllabus Cards */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          {syllabusOptions.map((syllabus) => (
            <div
              key={syllabus.name}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
            >
              <div className={`h-32 bg-gradient-to-r ${syllabus.gradient} relative overflow-hidden`}>
                <div className="absolute inset-0 bg-black/20"></div>
                <div className="absolute bottom-4 left-6 flex items-center gap-3">
                  <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <syllabus.icon className="text-white" size={24} />
                  </div>
                  <h2 className="text-2xl font-bold text-white">{syllabus.name}</h2>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {syllabus.description}
                </p>

                <div className="space-y-2">
                  <h3 className="font-semibold text-gray-800 mb-3">Key Features:</h3>
                  {syllabus.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className={`w-2 h-2 bg-${syllabus.color}-500 rounded-full`}></div>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Ready to Get Started?
            </h2>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
              Choose your syllabus and connect with expert tutors who specialize in your curriculum
            </p>
           <NavLink to="/about" className="btn btn-primary btn-lg gap-2">
              Register for Demo Class
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyllabusPage;